import React, { useRef, useState } from 'react'
import Header from './Core/Header'
import { useNavigate } from 'react-router-dom'
import { checkByAadhaar, createDoctor, loginDoctor, sendOtp } from '../service/operations/api_methods'
import { useDispatch } from 'react-redux'
import { login } from '../redux/slices/authSlice'
import { toast } from 'sonner'


const OTP_LENGTH = 4;
const Home = () => {
  const navigate=useNavigate()
  const[formType,setFormType]=useState("login")
  const [aadhaar_id,setAadhaar_id]=useState('')
  const[primary_number,setPrimary_number]=useState('')
   const [otp, setOtp] = useState(new Array(OTP_LENGTH).fill(""));
  const inputRefs = useRef([]);

//  const {first_name,last_name,aadhaar_id,email,gender,profile_image,primary_number,dob,license_number,specialist_type,experience_years}=data
 const[first_name,setfirst_name]=useState("")
 const[last_name,setlast_name]=useState("")
 const[email,setEmail]=useState("")
 const[gender,setGender]=useState("")
 const[profile_image,setprofile_image]=useState(null)
 const[dob,setDob]=useState("")
 const[license_number,setlicense_number]=useState("")
 const[specialist_type,setspecialist_type]=useState("")
 const[experience_years,setexperience_years]=useState("")

 const dispatch = useDispatch();

  const handleSendOtp=async(num)=>{
    console.log(num);
    
    try {
      const res=await sendOtp(num)
      console.log(res,);
      if(res.status===200){
        // Fixed: changed comma to plus for alert concatenation
        alert('Otp: ' + res.data.data.otp) 
        console.log("otp is: ",res.data.data.otp);
        
          setFormType('user')
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }

const handlecheckuserByAadhaar=async(e)=>{
  e.preventDefault()
  try {
    const res=await checkByAadhaar(aadhaar_id)
    console.log(res);
    
  } catch (error) {
    console.log(error);
    
        
        if(error.data.action==='LOGIN_DOCTOR'){
        setPrimary_number(error.data.data.primary_number)
          handleSendOtp(error.data.data.primary_number)
          toast.info('Otp has been send')
        }else if(error.data.action==="REGISTER_FIRST"){
          setFormType('register')
          toast.info("New user to this system, register first")
        }else if(error.data.action==="REGISTER_DOCTOR"){
          setPrimary_number(error.data.data.primary_number)
          setFormType('doc-create')
          toast.info('Create doctor account')
        }
    
    
  }
}

// ✅ UPDATED LOGIN FUNCTION
const handleLogin=async(e)=>{
  e.preventDefault()
  try {

    const finalOtp = otp.join("")
    const res=await loginDoctor({mobile:primary_number,aadhaar_id,device_token:"fcmDeviceToken_ABC123XYZ",otp:finalOtp})
    
    console.log("Login Response:", res); // Check this in console if issues persist

    if(res.status===200){
       const data = res.data.data;

       // 1. Dispatch to Redux
       dispatch(
         login({
           token: data.token,
           user: data,
         })
       )

       // 2. ✅ SAVE TO LOCAL STORAGE (Crucial for FindHospitals page)
       localStorage.setItem("token", data.token);

       // 3. ✅ ROBUST ID SAVING
       // Checks common ID names (id, user_id, _id, doctor_id) to ensure it works
       const userId = data.id || data.user_id || data._id || data.doctor_id || (data.user && data.user.id);
       
       if (userId) {
           localStorage.setItem("id", userId);
           console.log("✅ ID Saved to Storage:", userId);
       } else {
           console.error("❌ ID not found in login response");
           alert("Login successful, but User ID is missing.");
       }

       toast.success('Logged in Successfully')
       navigate('/dashboard')
    }
    
  } catch (error) {
    console.log(error);
    toast.error("Login Failed")
  }
}

const handleCreateDoctor=async(e)=>{
  e.preventDefault()
  let data={first_name,last_name,aadhaar_id,email,gender,profile_image,primary_number,dob,license_number,specialist_type,experience_years}
 console.log(data);

  try {
    const res=await createDoctor(data)
    console.log(res);
    if(res.status===200){
      setFormType('login')
      toast.info("Account ceated, Login now")
    }
   // 
  } catch (error) {
    console.log(error);
    
  }
}

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return; // only digits

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

    const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };






  return (
    <div className='w-full bg-gray-500 h-[100vh]'>
      <Header/>
      <section style={{marginTop:"70px"}}>
      <div
      style={{
        width: "100%",              // full width of container
        height: "100vh",            // final visible height you want
        overflow: "hidden",         // hides the cropped part
        borderRadius: "15px",       // optional, for rounded corners
        position: "relative",
      }}
    >
      <video
        src="/Assets/biotech1.mp4"   // your video file
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: "100%",
          height: "auto",           // ensures scaling
          position: "absolute",
              filter: "blur(2px)",         // crop from top (adjust this value)
          objectFit: "cover",       // ensures it fills the area
        }}
      />

      <div style={{position:"absolute",zIndex:90,top:"10vh",left:"1vw",display:"flex",alignItems:"center",justifyContent:"center",gap:"30px"}}>
       <div style={{display:"flex",flexDirection:"column",width:"50%"}}> 
        <p style={{ color: "#fff", // white text
          fontSize: "58px",
          fontWeight: "bold",
          textAlign: "center",
          width:"100%",
          textShadow: `
            0 0 3px #000000ff,
            0 0 6px rgba(158, 158, 158, 1),
            0 0 9px rgba(221, 221, 221, 1)
          `,}}>
          Connecting Care, Expertise, and Patients Seamlessly</p>
        <p style={{fontSize:"28px",fontWeight:"700",color:"white",width:"100%",textAlign:"center"}}>Empowering hospitals, doctors, and diagnostic centers with a unified platform for smarter healthcare collaboration.</p>
      </div>
      <div style={{width:"50%",height:"70vh",margin:"20px",
           backdropFilter: "blur(10px)",       // blur effect
    backgroundColor: "rgba(255, 255, 255, 0.2)", // transparent background (20% white)
    WebkitBackdropFilter: "blur(20px)",
    borderRadius:"15px",  boxShadow: "0 0 15px 3px rgba(0,0,0,0.25)",
    display:"flex",flexDirection:"column",alignItems:"center"
      }}>
        <p style={{fontSize:"30px",fontWeight:"700",textAlign:"center",color:"white",
          textShadow: `
            0 0 3px #000000ff,
            0 0 6px rgba(158, 158, 158, 1),
            0 0 9px rgba(221, 221, 221, 1)
          `,marginTop:"20px"
        }}>
          {formType==="login"?"Login to Account"
          :formType==="user"?"Submin OTP"
        :"Register your Account"}
          </p>


       {formType==="login"? 
       <form style={{margin:"30px",padding:"20px",borderRadius:"10px",backgroundColor:"#b1ddfaff",
           display:"flex",flexDirection:"column",alignItems:"center"
        }}>
          <p style={{color:'gray',fontWeight:"bold"}}>Aadhaar No</p>
          <input style={{
            width:'100%',
            padding:"8px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={aadhaar_id}
          onChange={(e)=>setAadhaar_id(e.target.value)}
          placeholder='1234 1234 1234 1234'/>
          <button onClick={handlecheckuserByAadhaar}
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX"
          }}>Login</button>
          
          <p style={{fontSize:"14px",color:"gray"}}>New to this Platform? {" "}
            {/* THIS IS THE CHANGE: setFormType("register") instead of "user" */}
            <span onClick={()=>setFormType("register")}
            style={{color:"black",cursor:"pointer"}}>Register</span> </p>
        </form>
      :formType==="user"? // otp modal , when user is present
       <form style={{margin:"30px",padding:"20px",borderRadius:"10px",backgroundColor:"#b1ddfaff",
           display:"flex",flexDirection:"column",alignItems:"center"
        }}>
          <p style={{color:'gray',fontWeight:"bold"}}>Otp</p>
          <div style={{display:"flex",justifyContent:"space-around",gap:"8px"}}>
          {otp.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            style={{
              width: "40px",
              height: "40px",
              textAlign: "center",
              fontSize: "18px",
              border: "1px solid gray",
              borderRadius: "6px",
              outline: "none",
            }}
          />
        ))}</div>

          <button onClick={handleLogin}
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX"
          }}>Verify</button>
          
          
        </form> 
        : //when user is not present
        formType==="doc-create"? // otp modal , when user is present
       <form style={{margin:"10px",padding:"20px",borderRadius:"10px",backgroundColor:"#b1ddfaff",
           display:"flex",flexDirection:"column",alignItems:"center",gap:"6px"
        }}>
        
     
          <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={license_number}
          onChange={(e)=>setlicense_number(e.target.value)}
          placeholder='Enter License Number'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={specialist_type}
          onChange={(e)=>setspecialist_type(e.target.value)}
          placeholder='Enter Specialist Type'/>
        </div>
         
          <div style={{display:"flex",gap:"10px"}}> 
        
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={experience_years}
          onChange={(e)=>setexperience_years(e.target.value)}
          placeholder='Enter Experience Year'/>
        </div>

        <input 
        onChange={(e)=>setprofile_image(e.target.files[0])}
        type='file'/>
          
          
          
          
          <button onClick={handleCreateDoctor}
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX"
          }}>Register</button>
          
          <p style={{fontSize:"14px",color:"gray"}}>Have account? {" "}
            <span onClick={()=>setFormType("login")}
            style={{color:"black",cursor:"pointer"}}>Login</span> </p>
        </form>  
        :
        <form style={{margin:"10px",padding:"20px",borderRadius:"10px",backgroundColor:"#b1ddfaff",
           display:"flex",flexDirection:"column",alignItems:"center",gap:"6px"
        }}>
        
         <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={first_name}
          onChange={(e)=>setfirst_name(e.target.value)}
          placeholder='Enter First name'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={last_name}
          onChange={(e)=>setlast_name(e.target.value)}
          placeholder='Enter Last name'/>
        </div>
          <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
          placeholder='Enter Email'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={primary_number}
          onChange={(e)=>setPrimary_number(e.target.value)}
          placeholder='Enter Primary Number'/>
        </div>
          <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={license_number}
          onChange={(e)=>setlicense_number(e.target.value)}
          placeholder='Enter License Number'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={specialist_type}
          onChange={(e)=>setspecialist_type(e.target.value)}
          placeholder='Enter Specialist Type'/>
        </div>
          <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={aadhaar_id}
          onChange={(e)=>setAadhaar_id(e.target.value)}
          placeholder='Enter Aadhaar Number'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={gender}
          onChange={(e)=>setGender(e.target.value)}
          placeholder='Enter gender'/>
        </div>
          <div style={{display:"flex",gap:"10px"}}> 
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          type='date'
          value={dob}
          onChange={(e)=>setDob(e.target.value)}
          placeholder='Enter date of birth'/>
          
          <input style={{
            width:'100%',
            padding:"4px",
            border:"1px solid gray",
            borderRadius:"5px",
            fontSize:"12px",
            outline:"none"
          }}
          value={experience_years}
          onChange={(e)=>setexperience_years(e.target.value)}
          placeholder='Enter Experience Year'/>
        </div>

        <input 
        onChange={(e)=>setprofile_image(e.target.files[0])}
        type='file'/>
          
          
          
          
          <button onClick={handleCreateDoctor}
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX"
          }}>Register</button>
          
          <p style={{fontSize:"14px",color:"gray"}}>Have account? {" "}
            <span onClick={()=>setFormType("login")}
            style={{color:"black",cursor:"pointer"}}>Login</span> </p>
        </form> 
      }

      </div>
      </div>
    </div>

      </section>

      
    </div>
  )
}

export default Home